import { SortInput } from 'components/Table'
import { AdUnitSortBy } from 'features/inventory/ad-unit/components/AdUnitsTable/types/model'

export const DEFAULT_SORT: SortInput<AdUnitSortBy> = {
  by: 'domain.name',
  direction: 'asc',
} as const

export const SORTABLE_COLUMNS: AdUnitSortBy[] = [
  'divId',
  'domain.name',
  'name',
  'path',
  'prebidStackEnabled',
  'priceGeniusEnabled',
  'refresherEnabled',
  'unfilledRecoveryEnabled',
  'updatedAt',
  'viewabilityToolsEnabled',
]
